import BaseAPI from './base/base-api';

class LoginAPI extends BaseAPI {
	constructor() {
		super();
	}
	urlName = 'ManagementAPI';
	controllerName = 'account';
}

export default new LoginAPI();
